module.exports = __webpack_public_path__ + "img/bg2.167d11b1.png";